<template>
	<div :class="[isPlans ? 'plans-container' : 'auth-container']">
		<div :class="{ 'auth-container': isPlans }" class="flex">
			<div>
				<a href="/">
					<img :src="logoSrc" alt="logo" class="logo" width="200">
				</a>
			</div>
			<div class="login-plans-header flex items-center">
				<nuxt-link
					v-if="isPlans"
					class="ml-25 button-light-blue tiny completed login-plans-header font-uppercase"
					:to="{ name: 'login', params: { logout: true } }"
				>
					{{ $tc('components.authHeader.signIn') }}
				</nuxt-link>
				<LanguageSelector class="ml-35" />
			</div>
		</div>
	</div>
</template>

<script>
import { LanguageSelector } from '~/components/interface'

export default {
	name: 'AuthHeader',
	components: {
		LanguageSelector
	},
	computed: {
		logoSrc () {
			return this.isPlans
				? '/my/images/pixellot-logo-white.png'
				: '/my/images/pixellot-logo-black.png'
		},
		isPlans () {
			const plansPages = ['plans', 'campaign-thanksgiving', 'plans-new', 'resellers']
			const isPlans = this.$route && plansPages.includes(this.$route.name)

			return isPlans && !this.$route.query.iframe
		},
		plansTitle () {
			if (this.$route.name === 'plans') {
				return this.$tc('components.authHeader.packagesText')
			} else if (this.$route.name === 'campaign-thanksgiving') {
				return 'Thanksgiving action'
			}

			return ''
		},
		plansText () {
			if (this.$route.name === 'plans') {
				return this.$tc('components.authHeader.helperText')
			} else if (this.$route.name === 'campaign-thanksgiving') {
				return 'Free limited trial Action team-plan ends on Dec 9th 2021'
			}

			return ''
		}
	}
}
</script>

<style lang="scss" scoped>
  .auth-container {
    padding: 35px 0;
    display: flex;
    justify-content: space-between;
    @include respond-below(tablet) {
      justify-content: space-around;
    }
    @include respond-below(phone) {
      height: 65px;
      align-items: center;
      .logo {
        height: 20px;
      }
    }

    .logo {
      position: relative;
      height: 25px;
    }
  }

  .plans-container {
    position: relative;
    z-index: 100;
    height: 100%;
    margin: 0 auto;
    &::before {
      @include bg-pseudo-image('/my/images/bg-header-small.png');
      background-size: 100% 100%;
    }
    @include respond-below(tablet) {
      &::before {
        background-position: initial;
        background-size: cover;
      }
    }
    @include respond-below(phone) {
      width: 100%;
      margin: 0;
    }

    .auth-container {
      height: auto;
    }
  }
</style>
